import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-clear',
  templateUrl: './layout-clear.component.html',
  styleUrls: ['./layout-clear.component.sass']
})
export class LayoutClearComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
